
import { Link } from "react-router-dom";

export default function AnswerContent({ answer }) {
	return (
		<div className="bg-white rounded-[10px] p-[10px]">
			<Link to={`/profile/${answer.profile_detail?.id}/`}>
				<div className="flex flex-row items-center">
					{answer.profile_detail?.avatar_url && (
						<>
							<div className="w-[40px] aspect-square">
								<img
									src={answer.profile_detail?.avatar_url}
									alt=""
									className="w-full h-full object-cover rounded-full"
								/>
							</div>
							<div className="spacer p-[5px]"></div>
						</>
					)}
					<div className="font-Vazir-400 text-[14px] text-[#666666]">{answer.profile_detail?.name}</div>
				</div>
			</Link>
			<div className="spacer p-[10px]"></div>
			<div className="font-Vazir-300 text-[14px] text-darkBlue">{answer.text}</div>
		</div>
	)
}
